<template>

<div>

  <LDBsTable
    url="garage-accredited"
    defaultSort="fantasyName"
    defaultOrder="asc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="fantasy_name">{{ $t('fantasy_name') }}</label>
      <input
        type="text"
        id="fantasy_name"
        name="fantasy_name"
        class="form-control"
        :placeholder="$t('type_fantasy_name')"
        v-model="query.fantasyName"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="social_reason">{{ $t('social_reason') }}</label>
      <input
        type="text"
        id="social_reason"
        name="social_reason"
        class="form-control"
        :placeholder="$t('type_social_reason')"
        v-model="query.socialReason"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="cpf_cnpj">{{ $t('cpf_cnpj') }}</label>
      <input
        type="text"
        id="cpf_cnpj"
        name="cpf_cnpj"
        class="form-control"
        :placeholder="$t('type_cpf_cnpj')"
        v-model="query.cpfCnpj"
        @input="query.cpfCnpj = query.cpfCnpj.toUpperCase()"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="email">{{ $t('email') }}</label>
      <input
        type="email"
        class="form-control"
        id="email"
        name="email"
        :placeholder="$t('type_email')"
        v-model="query.email"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="uf">{{ $t('uf') }}</label>
      <vue-select
        class="bg-white"
        name='uf'
        :placeholder="$t('select_a_item')"
        :options="ufs"
        v-model="query.uf"
        :select-on-tab='true'
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="city">{{ $t('city') }}</label>
      <input
        type="text"
        id="city"
        name="city"
        class="form-control"
        :placeholder="$t('type_city')"
        v-model="query.city"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="place_service">{{ $t('place_service') }}</label>
        <vue-select
          class="bg-white"
          name='place_service'
          :placeholder="$t('select_a_item')"
          :options="placeServices"
          v-model="query.placeService"
          :select-on-tab='true'
        />
    </div>

    <div class="col-lg-4 form-group">
      <label for="latitude">{{ $t('latitude') }}</label>
      <input
        type="text"
        id="latitude"
        name="latitude"
        class="form-control"
        :placeholder="$t('ph_latitude')"
        v-model="query.latitude"
      >
    </div>

    <div class="col-lg-4 form-group">
      <label for="longitude">{{ $t('longitude') }}</label>
      <input
        type="text"
        id="longitude"
        name="longitude"
        class="form-control"
        :placeholder="$t('ph_longitude')"
        v-model="query.longitude"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="isActive">{{ $t('active') }}</label>
        <Combobox
          class="bg-white"
          name='isActive'
          :placeholder="$t('select_a_item')"
          label="label"
          :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false }]"
          v-model="query.isActive"
          :reduce="isActive => isActive.value"
        />
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import { mapState } from 'vuex'
import { maskCpfCnpj, maskPhone } from '@/lib/staticMask'
import uf from '@/config/uf.js'
import placeService from '@/config/place-services'

export default {
  name: 'GarageAccreditedList',

  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('fantasy_name'),
          field: 'fantasyName',
          sortable: true
        },
        {
          title: this.$t('social_reason'),
          field: 'socialReason',
          sortable: true
        },
        {
          title: this.$t('cpf_cnpj'),
          field: 'cpfCnpj',
          formatter: maskCpfCnpj,
          sortable: true
        },
        {
          title: this.$t('uf'),
          field: 'uf',
          sortable: true
        },
        {
          title: this.$t('city'),
          field: 'city',
          sortable: true
        },
        {
          title: this.$t('phone') + ' 1',
          field: 'phone1',
          formatter: maskPhone,
          sortable: true
        },
        {
          title: this.$t('phone') + ' 2',
          field: 'phone2',
          formatter: maskPhone,
          sortable: true
        },
        {
          title: this.$t('email'),
          field: 'email',
          sortable: true
        },
        {
          title: this.$t('place_service'),
          field: 'placeService',
          sortable: true
        },
        {
          title: this.$t('active'),
          field: 'isActive',
          formatter: function(value) {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          title: this.$t('latitude'),
          field: 'latitude',
          visible: false,
          sortable: true
        },
        {
          title: this.$t('longitude'),
          field: 'longitude',
          visible: false,
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/garageaccredited/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'oficinas_credenciadas' }
      },
      query: {
        id: '',
        fantasyName: '',
        socialReason: '',
        cpfCnpj: '',
        uf: '',
        city: '',
        phone1: '',
        phone2: '',
        email: '',
        placeService: '',
        latitude: '',
        longitude: '',
        isActive: true
      },
      queryToUse: {},
      ufs: uf,
      placeServices: placeService
    }
  },

  computed: {
    ...mapState({
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    clear() {
      this.query.fantasyName = '',
      this.query.socialReason = '',
      this.query.cpfCnpj = '',
      this.query.uf = '',
      this.query.city = '',
      this.query.phone1 = '',
      this.query.phone2 = '',
      this.query.email = '',
      this.query.placeService = '',
      this.query.latitude = '',
      this.query.longitude = '',
      this.query.isActive = undefined
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['garageaccredited'] ? this.lastquery['garageaccredited'] : this.query
  },

  mounted () {
    if (this.lastquery['garageaccredited']) {
      for (const [key, value] of Object.entries(this.lastquery['garageaccredited'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query
  },

  destroyed () {
    this.$store.dispatch('filtershistory/setQuery', { key: 'garageaccredited', query: this.query })
  },
}
</script>
